/* eslint-disable react/jsx-key */
// Station
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext, useEffect, useMemo } from 'react'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import {
  getKindleIntegrationMapping,
  kindleMySqlDaAwardSave,
  kindleMySqlDaAward,
} from 'api/pgads.js'
import CommonScreen from 'admin/component/CommonScreen'
import { Button, DatePicker, message, Select } from 'antd'

import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits, isValidYearRange } from 'core/utils'

import {
  DatePickerContext,
  ErrorContext,
  SpinContext,
  // UnitSelectionContext,
} from 'context'
import { CriteriaRow } from 'core/screen-util'
import { saveDataMessage } from 'kindle'

const headers = [
  dateCol({
    ident: 'runDate',
    display: 'Run Date',
    isFiltered: true,
    isRequired: true,
    width: 150,
    isEditable: false,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'hourEnding',
    display: 'Hour Ending',
    isFiltered: true,
    isEditable: false,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'location',
    display: 'Location',
    isFiltered: true,
    isEditable: false,
    width: 150,
    sortOrder: 'asc',
  }),
  numCol({
    displayFormat: '0.0000',
    ident: 'clearedMw',
    display: 'Cleared MW',
    isFiltered: true,
    isEditable: false,
    width: 200,
    sortOrder: 'asc',
  }),
]

const DaAward = ({
  title = 'DA Ahead Award',
  units,
  apiTargetInfo,
  ...props
}) => {
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const [integrationUnits, setIntegrationUnits] = useState([])
  const [selNames, setSelNames] = useState(['all'])
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  useEffect(
    _ => {
      getKindleIntegrationMapping(apiTargetInfo).fork(
        setError,
        integrationMapping => {
          const filteredIntegrationMapping = integrationMapping
            .filter(u => u.unitId)
            .filter(u => u.importType === 'AWARD')
            .map(k => k.kindleName)
          /// const newUnitList = units.filter(u => unitIds.includes(u.unitId))
          setIntegrationUnits(filteredIntegrationMapping)
        }
      )
    },
    [apiTargetInfo, setError, units]
  )

  const { authGodMode } = props.envConfig

  const actionPermits = props.actionPermits

  const kindleMySqlGenerationWritePermisiion = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.KINDLE_MYSQL_DA_AWARD_ADMIN],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const withCriteria = (_, _2, su, sd) => {
    return {
      date: sd,
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      location:
        selNames.length === 0 || selNames.includes('all')
          ? integrationUnits
          : selNames,
    }
  }

  const saveData = _ => {
    // const newUnitList = units.filter(u => unitIds.includes(u.unitId))
    // const unitnames = selectedUnits
    //   .filter(u => unitIds.includes(u.unitId))
    //   .map(u => u.unitName)

    setSpinning(true)
    kindleMySqlDaAwardSave(apiTargetInfo)({
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      location:
        selNames.length === 0 || selNames.includes('all')
          ? integrationUnits
          : selNames,
    }).fork(setError, _ => {
      setSpinning(false)
      // message.info('Data saved')
      saveDataMessage()
    })
  }

  const extraCriteriaAfterButton = _ => {
    if (kindleMySqlGenerationWritePermisiion)
      return (
        <Button type="danger" onClick={saveData} loading={spinning} icon="save">
          Save Remote Data
        </Button>
      )
    return <div />
  }

  const beforeRetrieveValidation = ({ validYearRange }) => {
    if (integrationUnits.length === 0) {
      message.warning('Please, Select Locations')
      return false
    }
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  const extraCriteria = ({ onCriteriaChnage }) => (
    <CriteriaRow
      css={{
        display: 'flex',
        gridTemplateColumns: '150px auto',
        paddingTop: '0px',
      }}
    >
      <div>Select Location : </div>
      <Select
        style={{ width: '85%' }}
        placeholder="Select Location"
        onChange={val => {
          setSelNames(val)
          onCriteriaChnage()
        }}
        mode="multiple"
        value={selNames}
        allowClear
      >
        <Select.Option key="all">All</Select.Option>
        {integrationUnits.map(i => (
          <Select.Option key={i} value={i}>
            {i}
          </Select.Option>
        ))}
      </Select>
    </CriteriaRow>
  )
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  return (
    <React.Fragment>
      <CommonScreen
        retrieveLabel="Retrieve Remote Data"
        beforeRetrieveValidation={beforeRetrieveValidation}
        extraCriteria={extraCriteria}
        screenCriteria={screenCriteria}
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        title={title}
        header={headers}
        retrieveTask={kindleMySqlDaAward}
        withCriteria={withCriteria}
        insertComp={false}
        insertCompHeight={90}
        heightOffset={270}
        allowInsert={false}
        isAdminScreen={false}
        withoutModify
        withDelete={false}
        isEditableGrid={_ => false}
        totalWidth={700}
        sortOptions={headers}
        initialSortOptions={headers}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(DaAward)
